<template>
    <div class="mRitual-container" v-observe-visibility="startAnimate">
        <div class="line" id="neonShadowR"></div>
        <img class="mRitual-banner" :src="banner" alt="Banner Ritual del Servido de la nueva Tecate 0.0 sin alcohol, disfruta de esta bebida sin alcohol a una temperatura de -2°C">
        <img class="mRitual-banner-mobile" :src="banner_mobile" alt="Banner Ritual del Servido de la nueva Tecate 0.0 sin alcohol, disfruta de esta bebida sin alcohol a una temperatura de -2°C">
        <h2 class="mRitual-title" :class="{animate: animate, onlySafari: isSafari}">Ritual de <br/> <span>servido</span></h2>
        <h3 class="mRitual-subtitle" :class="{animate: animate, onlySafari: isSafari}">Tómala <br/> <span class="text-one" :class="{onlySafari: isSafari}">bien <span class="text-two" :class="{onlySafari: isSafari}">fría</span></span></h3>
        <img class="mRitual-number" :src="number" :class="{animate: animate}" alt="temperatura de -2°C">
    </div>
</template>

<script>
import banner from '@/assets/ritual/BANNER_RITUAL.png';
import banner_mobile from '@/assets/ritual/BANNER_RITUAL_MOBILE.png';
import number from "@/assets/ritual/NUMBER.png";
import { mapGetters } from "vuex";
import Bowser from "bowser";

export default {
    name: "Ritual",
    data() {
        return {
            banner,
            banner_mobile,
            number,
            animate: false,
            isSafari: false
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },
    methods: {
        startAnimate(isVisible) {
            if(isVisible) {
                this.animate=true
            }
        },
    },
    components: {},
    mounted() {
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    }
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/Ritual.scss";
</style>